module.exports = __webpack_public_path__ + "16d64a0a88de62af81ec6188971b14c0.svg";